module.exports = __webpack_public_path__ + "static/img/8.1419143.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/3/eng/8.png
// module id = iogN
// module chunks = 0